import dayjs from 'dayjs';
import {
  faCheck,
  faQuestion,
  faRedoAlt,
  faTimes,
  type IconDefinition,
} from '@fortawesome/free-solid-svg-icons';

export const formatLaunchDate = (date: string | null | undefined): string =>
  date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : 'N/A';

export const statusIcon = (
  status: string | null | undefined,
): IconDefinition => {
  switch (status) {
    case 'success':
      return faCheck;
    case 'error':
      return faTimes;
    case 'running':
      return faRedoAlt;
    default:
      return faQuestion; // unknown status
  }
};
